<template>
    <div class="modal fade" id="modal-denunciante">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">{{view_nome}}</h4>
					<button type="button" class="close" @click="close">
						&times;
					</button>
				</div>

				<div class="modal-body">
                    <alert ref="alert" />

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>{{view_nome}}</label>
                                <select class="form-control form-control-sm" v-model="selected" @change="select_den">
                                    <option :value="{}">Adicionar novo</option>
                                    <option v-for="den in denunciantes" :key="den.id" :value="den">{{ den.id }} - {{ den.nome }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>Nome completo</label>
                                <input type="text" class="form-control form-control-sm" :class="[(denunciante.nome) ? '' : incomplete]" v-model="denunciante.nome">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Telefone</label>
                                <input type="text" class="form-control form-control-sm" v-model.number="denunciante.telefone" v-mask="['(##) ####-####', '(##) #####-####']">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Email</label>
                                <input type="text" class="form-control form-control-sm" v-model="denunciante.email">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Logradouro</label>
                                <input type="text" class="form-control form-control-sm" v-model="denunciante.logradouro">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Município</label>
                                <input type="text" class="form-control form-control-sm" v-model="denunciante.municipio">
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>UF</label>
                                <input type="text" class="form-control form-control-sm" v-model="denunciante.uf">
                            </div>
                        </div>
                    </div>
				</div>
				
				<div class="modal-footer">
                    <button class="btn btn-sm btn-primary" @click="save" title="Salvar alterações feitas.">Salvar</button>
					<button class="btn btn-sm btn-danger ml-1" @click="close" title="Fechar sem salvar.">Fechar</button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
    import api   from '@/mixins/api.js'
    import alert from '@/components/Tools/alert'

    export default {
        name: 'modal-denunciante',
        components: { alert },
        mixins: [ api ],

        data() { return {
			incomplete: false,
            denunciantes: [],
            denunciante: {},
            selected: null,
        }},

        created() {
            this.get_denunciantes()
        },

        computed: {
			view_nome(){ return this.$store.state.config_view_menu.denunciante_nome }
		},

        methods: {
            show(id) {
                this.selected = null

                if ( id ) this.get_denunciante(id)
                else this.denunciante = {}
                
                $("#modal-denunciante").modal()
            },

            select_den() {
                this.denunciante = this.selected
            },

            save() {
                 if ( !this.denunciante.nome ){
                    this.$refs.alert.alert('Campo nome é obrigatório!', 'alert-danger')
                    this.incomplete = "focus"
                 }
                else {
                    if ( this.denunciante.id )
                        this.update()

                    else this.create()
                }
            },

            close() {
                $("#modal-denunciante").modal('hide')
            },

            async get_denunciante(id) {
                const response = await this.GET('Denuncia/Denunciante/find', id)

                if ( response.status === 'success' )
                    this.denunciante = response.result

            },

            async get_denunciantes() {
                const response = await this.GET('Denuncia/Denunciante')

                if ( response.status === 'success' )
                    this.denunciantes = response.result
            },

            async update() {
                const response = await this.PUT('Denuncia/Denunciante/edit', this.denunciante)
                
                if (response.status === 'success') {
                    this.close()
                    this.$emit('save', response.result.id)
                }

                else this.$refs.alert.alert('Erro ao atualizar dados.', 'alert-danger')
            },

            async create() {
                const response = await this.POST('Denuncia/Denunciante/create', this.denunciante)

                if (response.status === 'success') {
                    this.close()
                    this.$emit('save', response.result.id)
                }

                else this.$refs.alert.alert('Erro ao gravar dados.', 'alert-danger')
            },
        }
    }
</script>